export class LoginDto {
  cloud: string;
  user: string;
  password: string;
  passwordEncrypted: boolean;
}
